import { post } from './ApiHelper'
import config from '../config'

const { baseUrl } = config

// 登录
export const login = ({ username = '', password = '' }) => {
  let url = baseUrl + '/userLogin'
  const formData = new FormData()
  formData.append('username', username)
  formData.append('password', password)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查看申报权限
export const queryScheduleState = () => {
  let url = baseUrl + '/queryScheduleState'
  return post(url)
}

// 待提交查询
export const queryExistingbuildingByUseridWaiting = ({ userid = '', currentPage = '', pageSize = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/queryExistingbuildingByUseridWaiting'
  const formData = new FormData()
  formData.append('userid', userid)
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 已提交查询
export const queryExistingbuildingByUseridSubmitted = ({ userid = '', currentPage = '', pageSize = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/queryExistingbuildingByUseridSubmitted'
  const formData = new FormData()
  formData.append('userid', userid)
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 升级查询
export const queryExistingbuildingByUseridUpgrade = ({ userid = '', currentPage = '', pageSize = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/queryExistingbuildingByUseridUpgrade'
  const formData = new FormData()
  formData.append('userid', userid)
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 添加技术目录
export const createDeclareLevel = ({ project_declare_id = '', level_id = '', technology_introduce = '', dlfileaddress = {} }) => {
  let url = baseUrl + '/createDeclareLevel'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报id
  formData.append('level_id', level_id) // 二级目录id
  formData.append('technology_introduce', technology_introduce) // 详情描述
  dlfileaddress && dlfileaddress.forEach(file => {
    formData.append('dlfileaddress', file)
  })
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询技术目录
export const findTwoLevelByOneLevelid = ({ onelevelid = '' }) => {
  let url = baseUrl + '/TwoLevel/findTwoLevelByOneLevelid'
  const formData = new FormData()
  formData.append('onelevelid', onelevelid) // 一级目录编号
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除技术目录信息
export const deleteDeclareLevelBydlId = ({ project_declare_id = '', level_id = '' }) => {
  let url = baseUrl + '/deleteDeclareLevelBydlId'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  formData.append('level_id', level_id) // 目录id
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询该申报下的创新项信息
export const findInnovateTechnologyByPid = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/findInnovateTechnologyByPid'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除技术目录中附件
export const deleteDeclareLevelByPidLidFileaddress = ({ project_declare_id = '', level_id = '', dl_file_address = '' }) => {
  let url = baseUrl + '/deleteDeclareLevelByPidLidFileaddress'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  formData.append('level_id', level_id) // 目录id
  formData.append('dl_file_address', dl_file_address) // 文件路径
  let params = {
    body: formData
  }
  return post(url, params)
}

// 添加项目申报
export const createExistingbuildingDeclare = (
  { id = '',
    user_id = '', // 用户账号id
    items_name = '', // 项目名称
    company_name = '', // 主申报单位
    unite_company_name = '', // 联合申报单位
    construction_company_name = '', // 建设单位（业主单位）
    construction_place = '', // 项目建设地点
    construction_time = '', // 项目建设时间
    address = '', // 联系地址
    legal_person = '', // 主申报单位法人
    legal_person_phone = '', // 法人电话
    linkman = '', // 联系人
    position = '', // 职务
    email = '', // 邮箱
    cellphone = '', // 手机号
    telephone = '', // 座机
    fax = '', // 传真
    award_type, // 申报评定类型1铂金奖  2金奖   3银奖
    award, // 现有评定类型1铂金奖  2金奖   3银奖 0普通申报
    overview = '', // 项目概况
    benefit = '', // 社会效益和经济效益
    operability = '', // 可操作性和示范性
    state = '', // 申请信息的状态
    overviewPICs = '', // 项目概况的图片
    benefitPICs = '', // 社会效益和经济效益图片
    operabilityPICs = '', // 可操作性和示范性图片
    items = '',
    project_type = [], // 项目类型
    dwell_other = '', // 居住其他
    public_other = '' // 公共其他
  }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/createExistingbuildingDeclare'
  const formData = new FormData()
  formData.append('id', id)
  formData.append('user_id', user_id)
  formData.append('items_name', items_name)
  formData.append('company_name', company_name)
  formData.append('unite_company_name', unite_company_name)
  formData.append('construction_company_name', construction_company_name)
  formData.append('construction_place', construction_place)
  formData.append('construction_time', construction_time)
  formData.append('legal_person', legal_person)
  formData.append('legal_person_phone', legal_person_phone)
  formData.append('address', address)
  formData.append('linkman', linkman)
  formData.append('position', position)
  formData.append('email', email)
  formData.append('cellphone', cellphone)
  formData.append('telephone', telephone)
  formData.append('fax', fax)
  formData.append('award_type', award_type)
  formData.append('award', award)
  formData.append('overview', overview)
  formData.append('benefit', benefit)
  formData.append('operability', operability)
  formData.append('state', state)
  overviewPICs && overviewPICs.forEach(file => {
    formData.append('overviewPICs', file)
  })
  benefitPICs && benefitPICs.forEach(file => {
    formData.append('benefitPICs', file)
  })
  operabilityPICs && operabilityPICs.forEach(file => {
    formData.append('operabilityPICs', file)
  })
  formData.append('items', items)
  formData.append('project_type', project_type)
  formData.append('dwell_other', dwell_other)
  formData.append('public_other', public_other)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 修改申报信息
export const updateExistingbuildingDeclare = (
  { id = '',
    user_id = '', // 用户账号id
    items_name = '', // 项目名称
    company_name = '', // 主申报单位
    unite_company_name = '', // 联合申报单位
    construction_company_name = '', // 建设单位（业主单位）
    construction_place = '', // 项目建设地点
    construction_time = '', // 项目建设时间
    address = '', // 联系地址
    legal_person = '', // 主申报单位法人
    legal_person_phone = '', // 法人电话
    linkman = '', // 联系人
    position = '', // 职务
    email = '', // 邮箱
    cellphone = '', // 手机号
    telephone = '', // 座机
    fax = '', // 传真
    award_type, // 申报评定类型1铂金奖  2金奖   3银奖
    award, // 现有评定类型1铂金奖  2金奖   3银奖 0普通申报
    overview = '', // 项目概况
    benefit = '', // 社会效益和经济效益
    operability = '', // 可操作性和示范性
    state = '', // 申请信息的状态
    overviewPICs, // 项目概况的图片
    benefitPICs, // 社会效益和经济效益图片
    operabilityPICs, // 可操作性和示范性图片
    items = '',
    project_type = [], // 项目类型
    dwell_other = '', // 居住其他
    public_other = '' // 公共其他
  }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/updateExistingbuildingDeclare'
  const formData = new FormData()
  formData.append('id', id)
  formData.append('user_id', user_id)
  formData.append('items_name', items_name)
  formData.append('company_name', company_name)
  formData.append('unite_company_name', unite_company_name)
  formData.append('construction_company_name', construction_company_name)
  formData.append('construction_place', construction_place)
  formData.append('construction_time', construction_time)
  formData.append('legal_person', legal_person)
  formData.append('legal_person_phone', legal_person_phone)
  formData.append('address', address)
  formData.append('linkman', linkman)
  formData.append('position', position)
  formData.append('email', email)
  formData.append('cellphone', cellphone)
  formData.append('telephone', telephone)
  formData.append('fax', fax)
  formData.append('award_type', award_type)
  formData.append('award', award)
  formData.append('overview', overview)
  formData.append('benefit', benefit)
  formData.append('operability', operability)
  formData.append('state', state)
  overviewPICs && overviewPICs.forEach(file => {
    formData.append('overviewPICs', file)
  })
  benefitPICs && benefitPICs.forEach(file => {
    formData.append('benefitPICs', file)
  })
  operabilityPICs && operabilityPICs.forEach(file => {
    formData.append('operabilityPICs', file)
  })
  formData.append('items', items)
  formData.append('project_type', project_type)
  formData.append('dwell_other', dwell_other)
  formData.append('public_other', public_other)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 根据id查询申报信息
export const getEBByID = ({ id = '' }) => {
  let url = baseUrl + '/getEBByID'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 添加创新项
export const createInnovateTechnology = ({ project_declare_id = '', it_name = '', introduce = '', fileaddresss, grade = '' }) => {
  let url = baseUrl + '/createInnovateTechnology'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('it_name', it_name)
  formData.append('introduce', introduce)
  fileaddresss && fileaddresss.forEach(file => {
    formData.append('fileaddresss', file)
  })
  formData.append('grade', grade)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 下载申报Word文档资料
export const downloadDocument = ({ id = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/downloadDocument'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除（项目概况，经济效益，可操作性）文件
export const deleteImageByPidAddress = ({ id = '', address = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/deleteImageByPidAddress'
  const formData = new FormData()
  formData.append('id', id) // 申报id
  formData.append('address', address) // 文件路径
  let params = {
    body: formData
  }
  return post(url, params)
}

// 上传沿用附件
export const createDeclare = ({ project_declare_id = '', declarefile }) => {
  let url = baseUrl + '/createDeclare'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('declarefile', declarefile)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 申报上传pdf文件
export const uploadPDF = ({ project_declare_id = '', pdffile = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/uploadPDF'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('pdffile', pdffile)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 已寄送（提交）
export const updateSendstate = ({ id = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/updateSendstate'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询该申报填写过的技术说明
export const getDeclareLevelByProId = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/getDeclareLevelByProId'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查看技术说明详情
export const queryDeclareLevelByPidAndLevelid = ({ project_declare_id = '', level_id = '' }) => {
  let url = baseUrl + '/queryDeclareLevelByPidAndLevelid'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('level_id', level_id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查看单个创新项详情
export const findInnovateTechnologyInfo = ({ project_declare_id = '', it_name = '' }) => {
  let url = baseUrl + '/findInnovateTechnologyInfo'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('it_name', it_name)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除创新项中的单个附件信息
export const deleteInnovateTechnologyByPidItnameAddress = ({ project_declare_id = '', it_name = '', file_address = '' }) => {
  let url = baseUrl + '/deleteInnovateTechnologyByPidItnameAddress'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  formData.append('it_name', it_name) // 目录id
  formData.append('file_address', file_address) // 文件路径
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询是否是会员单位
export const isDeclareUnit = ({ unitName = '' }) => {
  let url = baseUrl + '/isDeclareUnit'
  const formData = new FormData()
  formData.append('unitName', unitName) // 申报Id
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询已上传的PDF文件
export const queryPdf = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/queryPdf'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  let params = {
    body: formData
  }
  return post(url, params)
}
// 删除PDF文件
export const deletePdf = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/deletePdf'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询沿用技术文件
export const getDeclareFile = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/getDeclareFile'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  let params = {
    body: formData
  }
  return post(url, params)
}
// 删除沿用技术文件
export const deleteDeclareFile = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/deleteDeclareFile'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id) // 申报Id
  let params = {
    body: formData
  }
  return post(url, params)
}

// 修改补充资料（项目概况，经济效益，可操作性）
export const replenishData = ({ id = '', overview = '', benefit = '', operability = '', overviewPICs, benefitPICs, operabilityPICs }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/replenishData'
  const formData = new FormData()
  formData.append('id', id)
  formData.append('overview', overview)
  formData.append('benefit', benefit)
  formData.append('operability', operability)
  overviewPICs && overviewPICs.forEach(file => {
    formData.append('overviewPICs', file)
  })
  benefitPICs && benefitPICs.forEach(file => {
    formData.append('benefitPICs', file)
  })
  operabilityPICs && operabilityPICs.forEach(file => {
    formData.append('operabilityPICs', file)
  })
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除创新项信息
export const deleteInnovateTechnologyByPidAndName = ({ project_declare_id = '', it_name = '' }) => {
  let url = baseUrl + '/deleteInnovateTechnologyByPidAndName'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('it_name', it_name)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 提交承诺书
export const updateIspromise = ({ id = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/updateIspromise'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 修改创新项信息
export const updateInnovateTechnology = ({ project_declare_id = '', it_name = '', introduce = '', fileaddresss, grade = '' }) => {
  let url = baseUrl + '/updateInnovateTechnology'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('it_name', it_name)
  formData.append('introduce', introduce)
  fileaddresss && fileaddresss.forEach(file => {
    formData.append('fileaddresss', file)
  })
  formData.append('grade', grade)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 补充资料（技术说明页下一步按钮）
export const backReplenishData = ({ id = '' }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/backReplenishData'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除项目
export const deleteEBById = ({ id = '' }) => {
  let url = baseUrl + '/deleteEBById'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询审核意见
export const queryMessageInfo = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/queryMessageInfo'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 升级申报
export const backupExistingbuildingDeclare = (
  { id = '',
    user_id = '', // 用户账号id
    items_name = '', // 项目名称
    company_name = '', // 主申报单位
    unite_company_name = '', // 联合申报单位
    construction_company_name = '', // 建设单位（业主单位）
    construction_place = '', // 项目建设地点
    construction_time = '', // 项目建设时间
    address = '', // 联系地址
    legal_person = '', // 主申报单位法人
    legal_person_phone = '', // 法人电话
    linkman = '', // 联系人
    position = '', // 职务
    email = '', // 邮箱
    cellphone = '', // 手机号
    telephone = '', // 座机
    fax = '', // 传真
    award_type, // 申报评定类型1铂金奖  2金奖   3银奖
    award, // 现有评定类型1铂金奖  2金奖   3银奖 0普通申报
    overview = '', // 项目概况
    benefit = '', // 社会效益和经济效益
    operability = '', // 可操作性和示范性
    state = '', // 申请信息的状态
    overviewPICs, // 项目概况的图片
    benefitPICs, // 社会效益和经济效益图片
    operabilityPICs, // 可操作性和示范性图片
    items = '',
    project_type = [], // 项目类型
    dwell_other = '', // 居住其他
    public_other = '' // 公共其他
  }) => {
  let url = baseUrl + '/ExistingbuildingDeclare/backupExistingbuildingDeclare'
  const formData = new FormData()
  formData.append('id', id)
  formData.append('user_id', user_id)
  formData.append('items_name', items_name)
  formData.append('company_name', company_name)
  formData.append('unite_company_name', unite_company_name)
  formData.append('construction_company_name', construction_company_name)
  formData.append('construction_place', construction_place)
  formData.append('construction_time', construction_time)
  formData.append('legal_person', legal_person)
  formData.append('legal_person_phone', legal_person_phone)
  formData.append('address', address)
  formData.append('linkman', linkman)
  formData.append('position', position)
  formData.append('email', email)
  formData.append('cellphone', cellphone)
  formData.append('telephone', telephone)
  formData.append('fax', fax)
  formData.append('award_type', award_type)
  formData.append('award', award)
  formData.append('overview', overview)
  formData.append('benefit', benefit)
  formData.append('operability', operability)
  formData.append('state', state)
  overviewPICs && overviewPICs.forEach(file => {
    formData.append('overviewPICs', file)
  })
  benefitPICs && benefitPICs.forEach(file => {
    formData.append('benefitPICs', file)
  })
  operabilityPICs && operabilityPICs.forEach(file => {
    formData.append('operabilityPICs', file)
  })
  formData.append('items', items)
  formData.append('project_type', project_type)
  formData.append('dwell_other', dwell_other)
  formData.append('public_other', public_other)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 上传文件
export const addFileInfo = ({ project_id = '', file, file_type = '', category = '' }) => {
  let url = baseUrl + '/addFileInfo'
  const formData = new FormData()
  formData.append('project_id', project_id)
  formData.append('file', file)
  formData.append('file_type', file_type)
  formData.append('category', category)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询文件列表
export const getFileList = ({ project_id = '', file_type = '', currentPage = '', pageSize = '' }) => {
  let url = baseUrl + '/getFileList'
  const formData = new FormData()
  formData.append('project_id', project_id)
  formData.append('file_type', file_type)
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除文件
export const delFileInfo = ({ id = '' }) => {
  let url = baseUrl + '/delFileInfo'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 下载单个技术目录
export const downLoadOneDeclareLevel = ({ project_declare_id = '', state = '', level_id = '' }) => {
  let url = baseUrl + '/downLoadOneDeclareLevel'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('state', state)
  formData.append('level_id', level_id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 下载技术目录+创新
export const downloadDeclareAndInno = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/downloadDeclareAndInno'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 下载单个创新项
export const downloadOneInno = ({ project_declare_id = '', it_name = '' }) => {
  let url = baseUrl + '/downloadOneInno'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  formData.append('it_name', it_name)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 下载全部创新项
export const downLoadAllInno = ({ project_declare_id = '' }) => {
  let url = baseUrl + '/downLoadAllInno'
  const formData = new FormData()
  formData.append('project_declare_id', project_declare_id)
  let params = {
    body: formData
  }
  return post(url, params)
}
